import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpenseSubmitted = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 17,
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .0703125,
			y: .373047,
			width: 15.9963,
			height: 16,
			rx: 7.99817,
			fill: "#3DD394"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_18898_117347)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M4.06836 8.12305L4.06836 5.37305C4.06836 4.26848 4.96379 3.37305 6.06836 3.37305H10.0684C11.1729 3.37305 12.0684 4.26848 12.0684 5.37305V10.873C12.0684 11.9776 11.1729 12.873 10.0684 12.873V12.873",
					stroke: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.56836 5.62305H6.56836",
					stroke: "white",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M7.56836 7.12305H6.56836",
					stroke: "white",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M5.84863 13.4336C5.64153 13.4336 5.47363 13.2657 5.47363 13.0586L5.47363 10.0586C5.47363 9.85149 5.64153 9.68359 5.84863 9.68359C6.05574 9.68359 6.22363 9.85149 6.22363 10.0586L6.22363 13.0586C6.22363 13.2657 6.05574 13.4336 5.84863 13.4336Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M7.86374 11.4184C7.71729 11.5649 7.47986 11.5649 7.33341 11.4184L6.72358 10.8086C6.24033 10.3253 5.45683 10.3253 4.97358 10.8086L4.36374 11.4184C4.21729 11.5649 3.97986 11.5649 3.83341 11.4184C3.68696 11.272 3.68696 11.0345 3.83341 10.8881L4.70841 10.0131C5.33811 9.3834 6.35904 9.3834 6.98874 10.0131L7.86374 10.8881C8.01019 11.0345 8.01019 11.272 7.86374 11.4184Z",
					fill: "white"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_18898_117347",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 12,
				height: 12,
				fill: "white",
				transform: "translate(2.06836 2.37305)"
			})
		}) })
	]
});
export default SvgExpenseSubmitted;
